import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { call } from "../utils/appData";
import WorkShell from "./AppPage";
export default function VerifyPaystackPayment() {
  const { search } = useLocation();
  const [status, setStatus] = useState("Verifying your payment…");
  const [success, setSuccess] = useState(false);
  const params = new URLSearchParams(search);
  const jobId = params.get("jobId");
  const productId = params.get("productId");
  useEffect(() => {
    let active = true;
    const p = new URLSearchParams(search);
    const reference = p.get("reference") || p.get("trxref");
    if (!reference) {
      setStatus("No payment reference found.");
      return;
    }
    call("verifyAndProcessPaystackPayment", {
      reference,
      type: p.get("type") || "product",
      productId: p.get("productId"),
      jobId: p.get("jobId"),
      creatorId: p.get("creatorId"),
      quoteId: p.get("quoteId"),
    })
      .then((r) => {
        if (active) {
          setSuccess(r.success === true);
          setStatus(
            r.success
              ? "Payment confirmed. Your account is being updated."
              : "Payment has not been confirmed yet.",
          );
        }
      })
      .catch((e) => {
        if (active) setStatus(e.message);
      });
    return () => {
      active = false;
    };
  }, [search]);
  return (
    <WorkShell title="Payment status">
      <section className="zy-card mb-[18px] rounded-[20px] border border-slate-200 bg-white p-[22px] dark:border-[#363e46] dark:bg-[#23272c] [&_h2]:mb-3 [&_h2]:text-[19px] [&_h2]:font-bold [&_h3]:mb-2 [&_h3]:text-[17px] [&_h3]:font-bold">
        <p role="status">{status}</p>
        <Link
          className="zy-button inline-flex min-h-11 cursor-pointer items-center justify-center gap-2 rounded-[14px] px-[17px] py-[11px] text-sm font-semibold disabled:cursor-wait disabled:opacity-50 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#49a3c9] bg-[#327691] text-white mt-5"
          to={
            jobId
              ? `/jobs/${jobId}`
              : productId
                ? `/product/${productId}`
                : "/dashboard"
          }
        >
          {success ? "Continue" : "Return"}
        </Link>
      </section>
    </WorkShell>
  );
}
